export default "__VITE_ASSET__ByVKs_RX__"